import { OfferingCircularsPage, OfferingCircularsPageResponse } from 'types/sanity/offering-circulars';
import { OfferingCircularsPageQuery } from './queries/offering-circulars-page';
import { useQuery } from 'villus';
import { villusClient } from '@utils/villus';

export async function getOfferingCircularsPage(): Promise<OfferingCircularsPage | null> {
	const { data } = await useQuery<OfferingCircularsPageResponse>({
		client: villusClient,
		query: OfferingCircularsPageQuery
	}).execute();

	return data?.allOfferingCirculars[0] ?? null;
}
